import type { Section } from '../models';
import { addDays, differenceInCalendarDays, differenceInCalendarMonths, format, isFuture, isPast } from 'date-fns';
import { LEASE_TERMS } from '.';

export function isYesNoEnabledForNumberedFields(section: Section, field: string, hasClickedNo: boolean): boolean {
  if (section.getFieldValue(field)) {
    return true;
  }
  return section.hasVisited || hasClickedNo ? false : null;
}

export function disablePastDates(date: Date) {
  return isPast(addDays(date, 1));
}

export function disable28DaysInPast(date: Date) {
  // 29 days is the correct number (28+1)
  return isPast(addDays(date, 29));
}

export function disableFutureDates(date: Date) {
  return isFuture(date);
}

export function getStartDayOfTheLeaseLabel(section: Section): string {
  const startDate = section.getFieldValue(LEASE_TERMS.FIELD_NAME.START_DATE);
  const formattedDate = startDate && format(startDate, 'MM/dd/yyyy');

  return `The lease start/move-in date ${formattedDate ? `(${formattedDate})` : ''}`;
}

export function calculateMonthsBetweenEndAndStartDate(section: Section): number {
  const startDate = section.getFieldValue(LEASE_TERMS.FIELD_NAME.START_DATE);
  const endDate = section.getFieldValue(LEASE_TERMS.FIELD_NAME.END_DATE);

  return differenceInCalendarMonths(new Date(endDate), new Date(startDate));
}

export function differenceInDaysBetweenDateAndToday(date: Date) {
  return differenceInCalendarDays(date, new Date().setUTCHours(0, 0, 0, 0));
}
